module.exports = __webpack_public_path__ + "static/img/20240927_4.3d26540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240927_4.png
// module id = b5dv
// module chunks = 0